export const SOCIAL_ICONS = [
  {
    src: process.env.REACT_APP_S3_IMGS_URL + "facebook.svg",
    href: 'https://www.facebook.com/VirtuaMetaverse/',
    alt: 'facebook'
  },
  {
    src: process.env.REACT_APP_S3_IMGS_URL + "twitter.svg",
    href: 'https://twitter.com/Virtuametaverse',
    alt: 'twitter'
  },
  {
    src: process.env.REACT_APP_S3_IMGS_URL + "instagram.svg",
    href: 'https://www.instagram.com/Virtuametaverse/',
    alt: 'instagram'
  },
  {
    src: process.env.REACT_APP_S3_IMGS_URL + "youtube.svg",
    href: 'https://www.youtube.com/VirtuaMetaverse',
    alt: 'youtube'
  },
  {
    src: process.env.REACT_APP_S3_IMGS_URL + "discord.svg",
    href: 'https://discord.com/invite/virtuaofficial',
    alt: 'discord'
  },
  {
    src: process.env.REACT_APP_S3_IMGS_URL + "medium.svg",
    href: 'https://medium.com/terravirtua',
    alt: 'medium'
  }
  // {
  //     src: process.env.REACT_APP_S3_IMGS_URL + "telegram.svg",
  //     href: "https://t.me/Virtuametaverse",
  //     alt: "telegram",
  // },
]
export const openCrib = async (riddle, ssoToken, build_link) => {
  try {
    let rediractLocation = new URL(window.location.origin)
    rediractLocation.searchParams.append('share_riddle', riddle)
    let url = new URL(build_link)
    url.searchParams.append('riddle', riddle)
    url.searchParams.append('redirect_uri', rediractLocation)
    //   url.searchParams.append('ssoToken', ssoToken)
    window.open(url, '_self')
  } catch (error) {
    console.log("openCrib error--->>", error)
  }
}

export const openProfile = async () => {
  try {
    window.open(`${process.env.REACT_APP_PROFILE_LINK}/wallet-connections`, '_self')
  } catch (error) {
    console.log("openProfile error--->>", error)
  }
}
